import { render, staticRenderFns } from "./RecipientPreviewEmail.vue?vue&type=template&id=69cba2b2&scoped=true"
import script from "./RecipientPreviewEmail.vue?vue&type=script&lang=js"
export * from "./RecipientPreviewEmail.vue?vue&type=script&lang=js"
import style0 from "./RecipientPreviewEmail.vue?vue&type=style&index=0&id=69cba2b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69cba2b2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VBtn,VCard})
